<template>
  <div class="detail-pekerjaan-wrapper">
    <div class="body-detail">
      <div class="header averta-bold">
        <div class="th first">
          <p class="label-16 ml-2">Detail Pekerjaan</p>
        </div>
        <div class="th sec">
          <p class="label-16 has-text-right">Volume<br />Pekerjaan</p>
        </div>
        <div class="th three">
          <p class="label-16 has-text-centered">Satuan</p>
        </div>
        <div class="th four">
          <p class="label-16 has-text-right">Harga Satuan</p>
        </div>
        <div class="th five">
          <p class="label-16 has-text-right">Total Harga</p>
        </div>
      </div>
      <div class="overflow-item-area">
        <div v-for="(area, index) in dataOffering.item_components" :key="`${index}-offer`">
          <div class="is-flex is-justify-content-space-between mb-4 mt-3">
            <p class="averta-black label-14">{{ area.area_name }}</p>
            <div
              class="averta-black label-14 is-flex is-justify-content-space-between pl-5"
              style="width: 10%"
            >
              <p>Rp</p>
              <p>{{ formatIdr(area.total_price, true) }}</p>
            </div>
          </div>
          <div v-for="(subArea, indexSubArea) in area.components" :key="`${indexSubArea}-subarea`">
            <p class="averta-bold ml-2 mb-3 label-14">{{ subArea.component_name }}</p>
            <div
              class="row-wrapper"
              v-for="(itemWorking, indexItemWorking) in subArea.item_components"
              :key="`${indexItemWorking}-item-working`"
            >
              <div class="td first is-flex">
                <div class="ml-2 c-w-100">
                  <div class="mb-4">
                    <div class="is-flex mb-3">
                      <p class="label-14">{{ itemWorking.numbering }}.</p>
                      <p class="label-14 ml-5">{{ itemWorking.note_item_working }}</p>
                      <div class="is-flex flex-wrap-sm-wrap" style="align-items: center;">
                        <!-- <div class="is-flex mb-3"> -->
                          <p class="label-14">{{ itemWorking.numbering }}.</p>
                          <p class="label-14 ml-5">{{ itemWorking.note_item_working }}</p>
                        <!-- </div> -->
                      <div v-if="itemWorking?.is_leakage">
                        <ButtonLeakage
                          :dataHeaderProps="{
                          is_leakage: itemWorking?.is_leakage || false,
                          isDisabled: true
                        }"/>
                      </div>
                      </div>
                    </div>
                    <div v-if="!hidePhoto" class="foto-wrapper ml-5">
                      <div
                        class="is-flex is-justify-content-space-between is-align-items-center mb-1"
                      >
                        <p class="averta-regular label-14">Foto Survey Konsultan</p>
                        <p
                          class="averta-bold color-red label-12 is-clickable"
                          @click="openModalImage(itemWorking.images)"
                        >
                          Lihat Foto
                        </p>
                      </div>
                      <div class="is-flex overflow-auto">
                        <div
                          class="foto-img mr-3 mb-1"
                          v-for="(image, indexImage) in itemWorking.images"
                          :key="`${indexImage}-img`"
                        >
                          <img
                            v-if="image.picture_url"
                            class="is-clickable"
                            :src="image.picture_url"
                            alt=""
                            @click="openModalImage(itemWorking.images)"
                          />
                          <img v-else :src="require('@/assets/img/empty-img-2.png')" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="td sec">
                <p class="label-14 has-text-right">{{ itemWorking.volume }}</p>
              </div>
              <div class="td three">
                <p class="label-14 has-text-centered">{{ itemWorking.unit_name }}</p>
              </div>
              <div class="td four is-flex is-justify-content-space-between">
                <p class="label-14">Rp</p>
                <p class="label-14">{{ formatIdr(itemWorking.unit_price, true) }}</p>
              </div>
              <div class="td five is-flex is-justify-content-space-between pl-5">
                <p class="label-14">Rp</p>
                <p class="label-14">{{ formatIdr(itemWorking.total_price, true) }}</p>
              </div>
            </div>
          </div>
          <div class="divider mb-5" v-if="index < dataOffering.item_components.length - 1"></div>
        </div>
      </div>

      <!-- Company -->
      <div v-if="clientTypeCompany">
        <!-- Doesn't Have a Discount -->
        <div
          v-if="dataOffering.prices && !dataOffering.prices.discount"
          class="footer-wrapper averta-bold"
        >
          <div v-if="dataOffering.prices && dataOffering.prices.subtotal" class="prices-wrapper">
            <div class="prices">
              <p>{{ isPriceTenant ? 'Total' : titleDPP }}</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>{{ formatIdr(dataOffering.prices && dataOffering.prices.subtotal, true) }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="dataOffering.prices && dataOffering.prices.discount_uses_markup"
            class="prices-wrapper"
          >
            <div class="prices">
              <p>Discount</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>
                  ({{
                    formatIdr(dataOffering.prices && dataOffering.prices.discount_uses_markup, true)
                  }})
                </p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices && dataOffering.prices.ppn" class="prices-wrapper">
            <div class="prices">
              <!-- <p>PPN {{ dataOffering.prices && dataOffering.prices.ppn_percent }}%</p> -->
              <p>PPN</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>{{ formatIdr(dataOffering.prices && dataOffering.prices.ppn, true) }}</p>
              </div>
            </div>
          </div>
          <div
            class="prices-wrapper"
            v-if="
              dataOffering.prices &&
              dataOffering.prices.pph &&
              !isPriceTenant &&
              dataOffering.prices.pph_percent !== 0 &&
              dataOffering.prices !== 0
            "
          >
            <div class="prices">
              <p class="white-space-nowrap">
                PPh Final 4 Ayat 2 ({{ dataOffering.prices && dataOffering.prices.pph_percent }}%)
              </p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>({{ formatIdr(dataOffering.prices && dataOffering.prices.pph, true) }})</p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices && dataOffering.prices.total || dataOffering.prices.total === 0" class="prices-wrapper last">
            <div class="prices">
              <p class="label-18 averta-bold">Grand Total</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p class="label-18 averta-black color-red">Rp</p>
                <p class="label-18 averta-black color-red">
                  {{ dataOffering.prices.total === 0 ? '0' : formatIdr(dataOffering.prices && dataOffering.prices.total, true) }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Discount -->
        <div
          v-else-if="
            (dataOffering.prices && dataOffering.prices.discount_uses_markup) ||
            (dataOffering.prices && dataOffering.prices.discount)
          "
          class="footer-wrapper averta-bold"
        >
          <div v-if="dataOffering.prices.subtotal" class="prices-wrapper">
            <div class="prices">
              <p>{{ isPriceTenant ? 'Total' : titleDPP }}</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>{{ formatIdr(dataOffering.prices && dataOffering.prices.subtotal, true) }}</p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices.discount_uses_markup" class="prices-wrapper">
            <div class="prices">
              <p>Discount</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>
                  ({{
                    formatIdr(
                      dataOffering.prices && dataOffering.prices.discount_uses_markup,
                      true
                    )
                  }})
                </p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices && dataOffering.prices.discount" class="prices-wrapper">
            <div class="prices">
              <p>Discount Tambahan</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>({{ formatIdr(dataOffering.prices && dataOffering.prices.discount, true) }})</p>
              </div>
            </div>
          </div>
          <div
            v-bind="dataOffering.prices && dataOffering.prices.total_after_discount"
            class="prices-wrapper"
          >
            <div class="prices">
              <p>{{ titleAfterDiscount }}</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>
                  {{
                    formatIdr(dataOffering.prices && dataOffering.prices.total_after_discount, true)
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices && dataOffering.prices.ppn" class="prices-wrapper">
            <div class="prices">
              <!-- <p>PPN {{ dataOffering.prices && dataOffering.prices.ppn_percent }}%</p> -->
              <p>PPN</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>{{ formatIdr(dataOffering.prices && dataOffering.prices.ppn, true) }}</p>
              </div>
            </div>
          </div>
          <div
            class="prices-wrapper"
            v-if="
              dataOffering.prices &&
              dataOffering.prices.pph &&
              !isPriceTenant &&
              dataOffering.prices.pph_percent &&
              dataOffering.prices
            "
          >
            <div class="prices">
              <p class="white-space-nowrap">
                PPh Final 4 Ayat 2 ({{ dataOffering.prices && dataOffering.prices.pph_percent }}%)
              </p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>({{ formatIdr(dataOffering.prices && dataOffering.prices.pph, true) }})</p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices && dataOffering.prices.total || dataOffering.prices.total === 0" class="prices-wrapper last">
            <div class="prices">
              <p class="label-18 averta-bold">Grand Total</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p class="label-18 averta-black color-red">Rp</p>
                <p class="label-18 averta-black color-red">
                  {{ dataOffering.prices.total === 0 ? '0' : formatIdr(dataOffering.prices && dataOffering.prices.total, true) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Company -->

      <!-- Personal -->
      <div v-if="clientTypePersonal">
        <!-- Doesn't Have a Discount -->
        <div
          v-if="
            dataOffering.prices &&
            !dataOffering.prices.discount &&
            !dataOffering.prices.discount_uses_markup
          "
          class="footer-wrapper averta-bold"
        >
          <div
            v-if="dataOffering.prices && dataOffering.prices.total || dataOffering.prices.total === 0"
            class="prices-wrapper last mt-4"
          >
            <div class="prices">
              <p class="label-18 averta-bold">Grand Total</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p class="label-18 averta-black color-red">Rp</p>
                <p class="label-18 averta-black color-red">
                  {{ dataOffering.prices.total === 0 ? '0' : formatIdr(dataOffering.prices && dataOffering.prices.total, true) }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Discount -->
        <div
          v-else-if="
            (dataOffering.prices && dataOffering.prices.discount_uses_markup) ||
            (dataOffering.prices && dataOffering.prices.discount)
          "
          class="footer-wrapper averta-bold"
        >
          <div v-if="dataOffering.prices && dataOffering.prices.subtotal" class="prices-wrapper">
            <div class="prices">
              <p>Total</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>{{ formatIdr(dataOffering.prices && dataOffering.prices.subtotal, true) }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="dataOffering.prices && dataOffering.prices.discount_uses_markup"
            class="prices-wrapper"
          >
            <div class="prices">
              <p>Discount</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>
                  ({{
                    formatIdr(dataOffering.prices && dataOffering.prices.discount_uses_markup, true)
                  }})
                </p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices && dataOffering.prices.discount" class="prices-wrapper">
            <div class="prices">
              <p>Discount Tambahan</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>({{ formatIdr(dataOffering.prices && dataOffering.prices.discount, true) }})</p>
              </div>
            </div>
          </div>
          <div
            v-if="dataOffering.prices && dataOffering.prices.total_after_discount"
            class="prices-wrapper"
          >
            <div class="prices">
              <p>{{ titleAfterDiscount }}</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p>Rp</p>
                <p>
                  {{
                    formatIdr(dataOffering.prices && dataOffering.prices.total_after_discount, true)
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="dataOffering.prices && dataOffering.prices.total || dataOffering.prices.total === 0" class="prices-wrapper last">
            <div class="prices">
              <p class="label-18 averta-bold">Grand Total</p>
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
                style="width: 160px"
              >
                <p class="label-18 averta-black color-red">Rp</p>
                <p class="label-18 averta-black color-red">
                  {{ dataOffering.prices.total === 0 ? '0' : formatIdr(dataOffering.prices && dataOffering.prices.total, true) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Personal -->

      <div class="wrap-terbilang label-16 has-text-right mt-3">
        <p>
          (<span class="averta-bold mr-1">Terbilang:</span>
          <span class="averta-regular-italic">{{
            formatSpellOut(dataOffering.prices && dataOffering.prices.total)
          }}</span
          >)
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, Terbilang } from '@/helpers'
import moment from 'moment'
import ButtonLeakage from '@/components/button/ButtonLeakage.vue'

export default {
  name: 'CardItemPreviewOffering',
  props: {
    dataOffering: {
      type: Object,
      default: () => {}
    },
    hidePhoto: {
      type: Boolean,
      default: false
    },
    selectedTipeOffering: String,
    countReject: {
      type: Number,
      default: 0
    }
  },
  components: {
    ButtonLeakage
  },
  data () {
    return {
      titleAfterDiscount: this.countReject > 1 ? 'Harga Sesudah Nego' : 'Harga Sesudah Discount'
    }
  },
  computed: {
    isPriceTenant () {
      return this.selectedTipeOffering === 'price-tenant'
    },
    clientTypeCompany () {
      return (
        this.dataOffering.client_type_code === 'company' ||
        this.dataOffering.client_type_code === null ||
        !this.dataOffering.client_type_code
      )
    },
    clientTypePersonal () {
      return this.dataOffering.client_type_code === 'personal'
    },
    titleDPP () {
      if (this.dataOffering.offering_created_date) {
        const createdDate = moment(
          this.dataOffering.invoice_created_date || this.dataOffering.offering_created_date
        )
        const thresholdDate = moment('2025-01-01')

        if (createdDate.isSameOrAfter(thresholdDate)) {
          return 'Harga Jual'
        } else {
          return 'DPP'
        }
      } else {
        return 'DPP'
      }
    }
  },
  methods: {
    formatIdr (value, hideCurrency) {
      return formatCurrency(value, hideCurrency)
    },
    formatSpellOut (value) {
      return Terbilang(value)
    },
    openModalImage (data) {
      this.$emit('openModalImage', data)
    }
  }
}
</script>

<style scoped>
.divider {
  border-top: 1px solid #e1e1e1;
}

.detail-pekerjaan-wrapper {
  border-radius: 20px;
  border: 1px solid #e1e1e1;
  padding: 20px;
  overflow: auto;
  margin-bottom: 2em;
}

.body-detail {
  width: 100%;
}

.header {
  display: flex;
  /* align-items: center; */
  border-bottom: 1px solid #e1e1e1;
  margin-bottom: 5px;
}

.row-wrapper {
  flex-shrink: 0;
}

.header .th,
.td {
  flex-shrink: 0;
  margin-bottom: 20px;
}

.th.numbering,
.td.numbering {
  width: 5%;
}

.th.first,
.td.first {
  width: 61%;
}

.th.sec,
.td.sec {
  width: 10%;
}

.th.three,
.td.three {
  width: 10%;
}

.th.four,
.td.four {
  width: 9%;
}

.th.five,
.td.five {
  width: 10%;
}

.row-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.foto-img {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.foto-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.foto-wrapper {
  border-radius: 16px;
  background: #fafafa;
  padding: 12px;
  width: 50%;
}

.prices-wrapper,
.prices {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.prices-wrapper {
  padding-top: 12px;
  padding-bottom: 12px;
}

.prices-wrapper.last {
  background: linear-gradient(90deg, #fffff7 0%, #fff5ea 100%);
  border-radius: 8px;
  padding-right: 12px;
  margin-right: -12px;
}

.prices {
  width: 24em;
  justify-content: space-between;
}

.footer-wrapper {
  border-top: 1px solid #e1e1e1;
}

.overflow-item-area {
  max-height: 500px;
  overflow-y: auto;
  padding-right: 0.8em;
  margin-right: -0.8em;
}
</style>
